import React, { Component } from 'react';
import LoginModal from './loginModal';
import LeftSide from './leftside';
import RightSide from './rightside';
import './style.less';

const B2cLogin = (props) => {
    return (
        <LoginModal {...props}>
            <div className="b2c__loginwrap--innersection">
                <RightSide {...props} translationId='B2CLogin' />
            </div>
        </LoginModal>
    )
}

export default B2cLogin;